import React from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux'
import { StdCard, StdForm } from 'components'
import { Cont, SContDetail, AttachmentGroup, AttachmentContent, AttachmentInfoContainer } from './styled'
import { FileRow } from './FileRow'
import { Divider, Button } from 'semantic-ui-react'

const Attachment = (props) => {
  const { blDetail = {} } = props
  const invoiceFile = (blDetail.billingAttachment || []).filter(x => x.documentCode === 'BL04')
  const receiptFile = (blDetail.billingAttachment || []).filter(x => x.documentCode === 'BL01')
  const otherFile = blDetail.otherAttachment || []
  const commentAttachments = blDetail.commentAttachments || []

  return (
    <React.Fragment>
      <StdForm title="Attachment">
        <Cont>
          <AttachmentInfoContainer>
            {blDetail.isServiceType ? <FileRow title='Invoice : ' attachments={invoiceFile} /> : null}
            <FileRow title='Receipt : ' attachments={receiptFile} />
            <FileRow title='Other documents : ' attachments={otherFile} />
          </AttachmentInfoContainer>
        </Cont>
      </StdForm>
      {
        commentAttachments.length !== 0 ?
          <StdCard title='Attachments By Comment'  >
            <Cont>
              {
                blDetail && blDetail.billingComment.map(a => {
                  let files = commentAttachments.filter(x => x.commentId === a.id)
                  if (files.length) {
                    return (
                      <AttachmentGroup>
                        <div className='attachmentBy'>
                          <span>{a.createdByName}</span>
                          <Moment format='DD MMM YYYY hh:mm'>{a.createdDate}</Moment>
                        </div>
                        <AttachmentContent>
                          {
                            files.map((f, i) =>
                              <SContDetail style={i === 0 ? { marginTop: '0px' } : null}>
                                <Button 
                                  type='button' 
                                  content={<div className='fileName'>{f.originalFilename}</div>} 
                                  icon='download' 
                                  labelPosition='left' 
                                  style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }} 
                                  onClick={() => (window.location.href = f.urlPath)} />
                              </SContDetail>
                            )
                          }
                          <Divider />
                        </AttachmentContent>
                      </AttachmentGroup>
                    )
                  } else {
                    return null
                  }
                })
              }
            </Cont>
          </StdCard>
          : null}
    </React.Fragment>
  )
}

const mapStateToProps = (state, props) => {
  return {}
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Attachment)